import * as yup from "yup";
import {FIELD_NAMES} from "./AskAQuestion.constanst";


export default function formValidationSchema() {
  return yup.object().shape({
    [FIELD_NAMES.NAME]: yup.string().required("Name is required"),
    [FIELD_NAMES.EMAIL]: yup.string().email().required("Email is required!"),
    [FIELD_NAMES.QUESTION]: yup.string().required("Question is required!"),
    [FIELD_NAMES.URGENCY]: yup.string().required("Urgency is required!"),
  })
}
